import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Producto } from '../../_models/producto';
import { ProductoAlerta } from '../../_models/producto-alerta';
import { ProductoAlertaService } from '../../_services/producto-alerta.service';

@Component( {
  selector: 'app-producto-alertas-editar',
  templateUrl: 'producto-alertas-editar.component.html'
} )

export class ProductoAlertasEditarComponent implements OnInit {

  @Input() producto: Producto;
  @Input() visualizar:boolean;
  @Input() idProductoAlerta: string;
  @Output() regresarListado: EventEmitter<any> = new EventEmitter<any>();
  public productoAlerta:ProductoAlerta;
  public carInformacionInicial:boolean = false;
  public procesando:boolean = false;

  constructor(private productosAlertaService:ProductoAlertaService){
  }

  ngOnInit(): void {
  }

  public abrirTab(event:any){
  }

  public regresar(){
    this.regresarListado.emit();
  }

  public recibirProductoAlerta(prodAlerta:ProductoAlerta){
    this.productoAlerta = prodAlerta;
    this.idProductoAlerta = prodAlerta.idProductoAlerta;
  }
}
